export const getEventProfile = state => {
    
    let jsonReqData
    jsonReqData = {
        id: state.props.id,
        budget_id: state.props.budget.id, 
        client_id: state.props.client.id, 
        consultant_id: state.props.consultant.id, 
        center_person: state.props.center_person,
        center_person_dob: state.props.center_person_dob,
        event_type_id: state.props.event.id, 
        event_date: state.props.event.event_date, 
        fall_back_event_date: state.props.event.fall_back_event_date,
        reservation_date: state.props.event.reservation_date, 
        start_at: state.props.event.start_at, 
        duration: state.props.event.duration, 
        guest_count: state.props.guests.default_count, 
        salon_id: state.props.salon.id, 
        salon_cost: state.props.salon.cost, 
        menu_id: state.props.menu.id, 
        menu_cost: state.props.menu.cost, 
        total_bill: state.props.total_bill,
        total_balance: state.props.total_balance,
        services: JSON.stringify(state.props.services_and_products.services), 
        observations: JSON.stringify(state.props.records.observations), 
        day_schedule: JSON.stringify(state.props.records.day_schedule), 
        documents: JSON.stringify(state.props.records.documents), 
        employees: JSON.stringify(state.props.services_and_products.employees), 
        consumables: JSON.stringify(state.props.services_and_products.consumables), 
        expenses: JSON.stringify(state.props.services_and_products.expenses), 
        payment_plan: state.props.billing_details.payment_plan, 
        interest_rate: state.props.billing_details.interest_rate, 
        discount_amount: state.props.billing_details.default_discount.amount, 
        discount_text: state.props.billing_details.default_discount.notes, 
        extra_billing: JSON.stringify(state.props.billing_details.extra_billing), 
        default_billing: JSON.stringify(state.props.billing_details.default_billing),
        payment_schedule: JSON.stringify(state.props.billing_details.payment_schedule),
        advance_percent: state.props.advance_percent,
        advance_due_days: state.props.advance_due_days,
        additional_clause: state.props.additional_clause,
        email_client: state.props.email_client ? 1 : 0,
        email_supplier: state.props.email_supplier ? 1 : 0,
        email_employee: state.props.email_employee ? 1 : 0,
        rescheduled: state.props.rescheduled ? 1 : 0,
        sign_percentage: state.props.sign_percentage,
        food_menu_details: JSON.stringify(state.props.catering.food_menu_details)
    }
    //return
    return jsonReqData

}

export const getEventList = state => {
    if(state.filterText.length>0) {
        return state.list.filter(function (element) {
            
            return element.budget_number.toLowerCase().match(state.filterText.toLowerCase()) ||
                   (element.client.name != null && element.client.name.toLowerCase().match(state.filterText.toLowerCase())) ||
                   (element.client.mobile_number != null && element.client.mobile_number.toLowerCase().match(state.filterText.toLowerCase())) ||
                   (element.client.email != null && element.client.email.toLowerCase().match(state.filterText.toLowerCase())) ||
                   element.event_date.replace(/-/g, "/") === state.filterText ||
                   element.fall_back_event_date.replace(/-/g, "/") === state.filterText
        });
        
    } else {
        return state.list
    }
    
}

export const getEventProp = state => {
    return state.props
}

export const getLoadingStatus = state => {
    return state.loading
}

export const getDayScheduleEdit = state => {
    return state.day_schedule_edit
}

export const getObservationEdit = state => {
    return state.observation_edit
}

export const getGuestList = state => {
    return state.guests.list
}

export const getTableLoading = state => {
    return state.table_loading
}

export const getClientMenuSelection = state => {
    return state.props.client_selection_food_menu
}


// WEBPACK FOOTER //
// ./src/store/modules/events/getters.js